export function onlyDigits(value) {
  return String(value === null || value === undefined ? '' : value).replace(/\D/g, '')
}

export function isValidEmail(value) {
  const email = String(value === null || value === undefined ? '' : value).trim()
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)
}

export function isValidCpf(value) {
  const cpf = onlyDigits(value)

  if (cpf.length !== 11) return false
  if (/^(\d)\1{10}$/.test(cpf)) return false

  for (let length = 9; length <= 10; length += 1) {
    let sum = 0

    for (let i = 0; i < length; i += 1) {
      sum += Number(cpf[i]) * (length + 1 - i)
    }

    let digit = (sum * 10) % 11
    if (digit === 10) digit = 0
    if (digit !== Number(cpf[length])) return false
  }

  return true
}

export function formatCpf(value) {
  const cpf = onlyDigits(value).slice(0, 11)

  return cpf
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
}

export function stripFlagEmoji(value) {
  return String(value === null || value === undefined ? '' : value)
    .replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '')
    .trim()
}

export function normalizeAddressNumber(value) {
  const raw = String(value === null || value === undefined ? '' : value)

  if (/^[Ss]\/?[Nn]?$/.test(raw)) return raw

  return onlyDigits(raw).slice(0, 10)
}
